/**
 * AI Fire API
 * API to access AI Fire sensor data
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The RelayData model module.
 * @module model/RelayData
 * @version 1.1.0
 */
class RelayData {
    /**
     * Constructs a new <code>RelayData</code>.
     * A representation of a Relay data.
     * @alias module:model/RelayData
     * @param id {String} 
     * @param status {String} 
     * @param connection {String} 
     * @param timeLastUpdate {Date} 
     */
    constructor(id, status, connection, timeLastUpdate) { 
        
        RelayData.initialize(this, id, status, connection, timeLastUpdate);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, id, status, connection, timeLastUpdate) { 
        obj['id'] = id;
        obj['status'] = status;
        obj['connection'] = connection;
        obj['timeLastUpdate'] = timeLastUpdate;
    }

    /**
     * Constructs a <code>RelayData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RelayData} obj Optional instance to populate.
     * @return {module:model/RelayData} The populated <code>RelayData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new RelayData();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'String');
            }
            if (data.hasOwnProperty('connection')) {
                obj['connection'] = ApiClient.convertToType(data['connection'], 'String');
            }
            if (data.hasOwnProperty('timeLastUpdate')) {
                obj['timeLastUpdate'] = ApiClient.convertToType(data['timeLastUpdate'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>RelayData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>RelayData</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of RelayData.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['id'] && !(typeof data['id'] === 'string' || data['id'] instanceof String)) {
            throw new Error("Expected the field `id` to be a primitive type in the JSON string but got " + data['id']);
        }
        // ensure the json data is a string
        if (data['status'] && !(typeof data['status'] === 'string' || data['status'] instanceof String)) {
            throw new Error("Expected the field `status` to be a primitive type in the JSON string but got " + data['status']);
        }
        // ensure the json data is a string
        if (data['connection'] && !(typeof data['connection'] === 'string' || data['connection'] instanceof String)) {
            throw new Error("Expected the field `connection` to be a primitive type in the JSON string but got " + data['connection']);
        }

        return true;
    }


}

RelayData.RequiredProperties = ["id", "status", "connection", "timeLastUpdate"];

/**
 * @member {String} id
 */
RelayData.prototype['id'] = undefined;

/**
 * @member {String} status
 */
RelayData.prototype['status'] = undefined;

/**
 * @member {String} connection
 */
RelayData.prototype['connection'] = undefined;

/**
 * @member {Date} timeLastUpdate
 */
RelayData.prototype['timeLastUpdate'] = undefined;






export default RelayData;

